import React from 'react';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { FormSubsectionType, RicMetadata } from '../ricFormTypes';
import { formatCurrency, calculateSumValue } from '../ricFormUtils';
import { SectionItem } from '../Components';
import { renderElement } from './SchemaFormElementRenderer';

export const SchemaSubSection = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  ricMetadata,
}: {
  formElement: FormSubsectionType;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
  ricMetadata?: RicMetadata;
}) => {
  const { title, subtitle, value, sumValue, subSectionElements } = formElement;

  const strValue = sumValue
    ? formatCurrency(calculateSumValue(responseData, sumValue))
    : (value ?? '');

  const renderSectionElements = () =>
    subSectionElements?.map((sectionElement) =>
      renderElement({
        formElement: sectionElement,
        responseData,
        fetchResponseWithUpdatedData,
        isSubSectionElement: true,
        ricMetadata,
      }),
    );

  return (
    <>
      <SectionItem title={title} subtitle={subtitle} value={strValue} />
      <div className="form-subsection">
        {subSectionElements && renderSectionElements()}
      </div>
    </>
  );
};

export default SchemaSubSection;
